import { Grid } from '@mui/material';

import { SortingObject } from '@/__configs/config_types';
import AdvanceSortListItem from '@/components/_common/Table/AdvanceSort/AdvanceSortListItem';

type AdvanceSortListProps = {
  sortFields: SortingObject[];
  onRemoveSort: (index: number) => void;
  onSortingChange: (index: number, id: SortingObject['id'], order: SortingObject['order']) => void;
};

function AdvanceSortList({ sortFields, onSortingChange, onRemoveSort }: AdvanceSortListProps) {
  return (
    <Grid
      container
      direction="column"
      rowGap={1.5}
      marginTop={2}
      flexWrap="nowrap"
    >
      {sortFields.map((sortField, index) => (
        <AdvanceSortListItem
          key={index}
          index={index}
          selectedColumn={sortField.id}
          selectedDirection={sortField.order}
          sortFields={sortFields}
          onSortingChange={onSortingChange}
          onRemoveSort={onRemoveSort}
        />
      ))}
    </Grid>
  );
}

export default AdvanceSortList;
